






































































































































































import { Vue, Component } from 'vue-property-decorator'
import BigNumber from 'bignumber.js'


@Component({ name: 'Tx' })
export default class Tx extends Vue {
    private error: Error | null = null
    private tx: Connex.Thor.Transaction | null = null
    private receipt: Connex.Thor.Receipt | null = null
    private id = ''

    get clauses() { return this.tx!.clauses }
    get totalTransferAmount() {
        let total = new BigNumber(0)
        this.clauses.forEach(c => {
            total = total.plus(c.value)
        })
        return total.toString()
    }
    get vip191() { return !!(this.tx as any).delegator }

    private async  reload() {
        this.error = null
        this.tx = null
        this.receipt = null

        try {
            const tv = this.$connex.thor.transaction(this.id)
            const [tx, receipt] = await Promise.all([
                tv.get(),
                tv.getReceipt()
            ])

            if (tx && receipt) {
                this.tx = tx
                this.receipt = receipt
            } else {
                this.error = new Error('not found')
            }
        } catch (err) {
            this.error = err
        }
    }

    private created() {
        this.$ga.page('/insight/tx')
        this.id = this.$route.params.id
        this.reload()
    }
}
